import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Flex,
  Dropdown,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  cancelMaterialRequest,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getVATDetails } from '../../../network/purchaseOrder';
import {
  getGetDetailsApi,
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import { getSupplier } from '../../../network/supplier';
import ItemOrderList from '../AddPurchaseOrder/ItemOrderList';
import TaxtList from '../AddPurchaseOrder/TaxtList';
import {
  addPurchaseReciept,
  getMapReferenceMakePR,
  getMapReferencePR,
  getPurchaseRecieptDetails,
  updatePurchaseReciept,
} from '../../../network/purchaseReciept';
import { FaFileInvoiceDollar } from 'react-icons/fa6';
import { MdOutlineReceiptLong, MdSubtitles } from 'react-icons/md';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { GiFiles, GiReturnArrow } from 'react-icons/gi';
import { TiCancel } from 'react-icons/ti';
import { SiKnowledgebase } from 'react-icons/si';
import HeadingApp from '../../../hooks/HeadingApp';
const AddPurchaseReciept = ({ t, edit, order, show, showReturn }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loadingTaxesDetails, setLoadingTaxesDetails] = useState(false);
  const [priceListSelect, setPriceListSelect] = useState();
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [taxesDetails, setTaxesDetails] = useState([]);
  const [searchtextSupplier, setSearchtextSupplier] = useState('');
  const { id, idOrder, idReturn, showReturnId } = useParams();
  const [dataSource, setDataSource] = useState([
    {
      warehouse: form.getFieldValue('set_warehouse'),
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddPurchaseReciept } = useMutation({
    mutationKey: ['addPurchaseReciept'],
    mutationFn: (body) =>
      edit ? updatePurchaseReciept(body, id) : addPurchaseReciept(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseReciept] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/purchase-receipt');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const {
    data: purchaseRecieptDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getPurchaseReciept, id],
    queryFn: () => getPurchaseRecieptDetails(id),
    enabled: !!edit,
  });
  const { data: purchaseReturnDetails, isLoading: isLoadingPurchaseReturn } =
    useQuery({
      queryKey: [queryKeys.getPurchaseReciept, showReturnId],
      queryFn: () => getPurchaseRecieptDetails(showReturnId),
      enabled: !!showReturn,
    });
  const {
    data: purchaseRecieptReturnDetails,
    isLoading: isLoadingPurchaseRecieptReturnDetails,
  } = useQuery({
    queryKey: [queryKeys.getPurchaseRecieptReturn, idReturn],
    queryFn: () => getMapReferencePR(idReturn),
    enabled: !!show,
  });
  const {
    data: mapReferenceMakePR,
    isLoading: isLoadingPurchaseRecieptDetails,
  } = useQuery({
    queryKey: [queryKeys.getMapReferenceMakePR, idOrder],
    queryFn: () => getMapReferenceMakePR(idOrder),
    enabled: !!order,
  });
  const { mutate: onGetTaxes, data: taxesList } = useMutation({
    mutationFn: (name) => getVATDetails('Purchase', name),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingTaxesDetails(false);
      setTaxesDetails(data?.message);
      // const disableRoundedTotal = form.getFieldValue('disable_rounded_total');
      // const netTotal = form.getFieldValue('net_total');
      // const totalRate = data?.message?.reduce((sum, item) => sum + item?.rate, 0);
      // const taxAmount = (netTotal * totalRate) / 100;
      // const grandTotal = netTotal + taxAmount;
      // const roundedTotal = disableRoundedTotal ? Math.round(grandTotal) : grandTotal;
      // const roundingAdjustment = (roundedTotal - grandTotal).toFixed(2);
      // form.setFieldsValue({grand_total: grandTotal,rounded_total:roundedTotal,rounding_adjustment:roundingAdjustment });
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Purchase Receipt', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      navigate('/purchase-receipt');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseReciept] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Purchase Receipt', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500 || !data) {
        message.error(data?._server_messages || 'Error occured');
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getPurchaseReciept, id],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const netTotalWatch = Form.useWatch('net_total', form);
  const disableRoundedTotalWatch = Form.useWatch('disable_rounded_total', form);
  useEffect(() => {
    if (taxesList || dataSource) {
      const netTotal = form.getFieldValue('net_total');
      const disableRoundedTotal = form.getFieldValue('disable_rounded_total');
      const totalRate = taxesList?.message?.reduce(
        (sum, item) => sum + item?.rate,
        0
      );
      const taxAmount = (netTotal * totalRate) / 100;
      const grandTotal = netTotal + taxAmount;
      const roundedTotal = disableRoundedTotal
        ? Math.round(grandTotal)
        : grandTotal;
      const roundingAdjustment = (roundedTotal - grandTotal).toFixed(2);
      form.setFieldsValue({
        grand_total: grandTotal,
        rounded_total: roundedTotal,
        rounding_adjustment: roundingAdjustment,
      });
    }
  }, [taxesList, form, dataSource, netTotalWatch, disableRoundedTotalWatch]);

  const disountApplyType = Form.useWatch('discount_type', form);

  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch],
    queryFn: () => getSearchApi('Price List'),
    keepPreviousData: true,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: 'Supplier',
        name: values,
        // fields: ['supplier_name', 'supplier_name_in_arabic'],
        fields: ['supplier_name'],
      }),
    onSuccess: (data) => {
      form.setFieldsValue({
        supplier_name: data?.message?.supplier_name,
        // supplier_name_in_arabic: data?.message?.supplier_name_in_arabic,
      });
    },
  });
  const { data: Supplier } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextSupplier],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Supplier',
        searchTxt: searchtextSupplier,
      }),
    keepPreviousData: true,

    enabled:
      searchtextSupplier?.length >= 3 || searchtextSupplier?.length === 0,
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () => getSearchApi('Purchase Taxes and Charges Template'),
    keepPreviousData: true,
  });
  const { data: suppliers } = useQuery({
    queryKey: [queryKeys.getSupplier],
    queryFn: () =>
      getSupplier({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (edit && purchaseRecieptDetails) {
      setDataStatus(purchaseRecieptDetails?.data?.docstatus);
      setTaxesDetails(purchaseRecieptDetails?.data?.taxes);
      onGetTaxes(purchaseRecieptDetails?.data?.taxes_and_charges);
      setDataSource(
        purchaseRecieptDetails?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseRecieptDetails?.data,
        posting_date: dayjs(purchaseRecieptDetails?.data?.posting_date),
        posting_time: dayjs(
          purchaseRecieptDetails?.data?.posting_time,
          'HH:mm'
        ),
      });
    } else {
      form.resetFields();
    }
  }, [edit, purchaseRecieptDetails, form]);
  useEffect(() => {
    if (showReturn && purchaseReturnDetails) {
      setTaxesDetails(purchaseReturnDetails?.data?.taxes);
      onGetTaxes(purchaseReturnDetails?.data?.taxes_and_charges);
      setDataSource(
        purchaseReturnDetails?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseReturnDetails?.data,
        posting_date: dayjs(purchaseReturnDetails?.data?.posting_date),
        posting_time: dayjs(purchaseReturnDetails?.data?.posting_time, 'HH:mm'),
      });
    } else {
      form.resetFields();
    }
  }, [showReturn, purchaseReturnDetails, form]);
  useEffect(() => {
    if (show && purchaseRecieptReturnDetails) {
      setTaxesDetails(purchaseRecieptReturnDetails?.message?.taxes);
      onGetTaxes(purchaseRecieptReturnDetails?.message?.taxes_and_charges);
      setDataSource(
        purchaseRecieptReturnDetails?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseRecieptReturnDetails?.message,
        posting_date: dayjs(
          purchaseRecieptReturnDetails?.message?.posting_date
        ),
        posting_time: dayjs(
          purchaseRecieptReturnDetails?.message?.posting_time,
          'HH:mm'
        ),
      });
    } else {
      form.resetFields();
    }
  }, [show, purchaseRecieptReturnDetails, form]);
  useEffect(() => {
    if (order && mapReferenceMakePR) {
      setTaxesDetails(mapReferenceMakePR?.message?.taxes);
      onGetTaxes(mapReferenceMakePR?.message?.taxes_and_charges);
      setDataSource(
        mapReferenceMakePR?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...mapReferenceMakePR?.message,
        posting_date: dayjs(mapReferenceMakePR?.message?.posting_date),
        posting_time: dayjs(mapReferenceMakePR?.message?.posting_time, 'HH:mm'),
      });
    } else {
      form.resetFields();
    }
  }, [edit, mapReferenceMakePR, form]);
  const onFinish = (values) => {
    //   console.log('Finish:', {
    //     ...values,
    //     posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
    //   });
    setLoadingAdd(true);
    if (show) {
      onAddPurchaseReciept({
        ...values,
        company: companyName,
        posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
        posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
        grand_total: Number(values?.grand_total),
        rounding_adjustment: Number(values?.rounding_adjustment),
        rounded_total: Number(values?.rounded_total),
        disable_rounded_total: Number(values?.disable_rounded_total),
        base_discount_amount: Number(values?.base_discount_amount),
        additional_discount_percentage: Number(
          values?.additional_discount_percentage
        ),
        items: dataSource?.map((item) => ({
          ...item,
          accepted_qty: item?.qty,
          received_qty: item?.qty,
          schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
        })),
        taxes: taxesList?.message?.map((tax) => ({ ...tax })),
        purchase_order: purchaseRecieptReturnDetails?.message?.purchase_order,
        return_against: purchaseRecieptReturnDetails?.message?.return_against,
        purchase_invoice_item:
          purchaseRecieptReturnDetails?.message?.purchase_invoice_item,
        purchase_receipt:
          purchaseRecieptReturnDetails?.message?.purchase_receipt,
      });
    } else {
      onAddPurchaseReciept({
        ...values,
        company: companyName,
        posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
        posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
        grand_total: Number(values?.grand_total),
        rounding_adjustment: Number(values?.rounding_adjustment),
        rounded_total: Number(values?.rounded_total),
        // disable_rounded_total: Number(values?.disable_rounded_total),
        base_discount_amount: Number(values?.base_discount_amount),
        set_posting_time: values?.set_posting_time ? 1 : 0,
        disable_rounded_total: values?.disable_rounded_total ? 1 : 0,
        is_return: values?.is_return ? 1 : 0,
        additional_discount_percentage: Number(
          values?.additional_discount_percentage
        ),
        items: dataSource?.map((item) => ({
          ...item,
          accepted_qty: item?.qty,
          received_qty: item?.qty,
          schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
        })),
        taxes: taxesList?.message?.map((tax) => ({ ...tax })),
      });
    }
  };
  if (
    isLoading ||
    isLoadingPurchaseRecieptDetails ||
    isLoadingPurchaseRecieptReturnDetails ||
    isLoadingPurchaseReturn
  ) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  // const itemsMenu = [
  //   {
  //     key: '1',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         style={{ width: '100%' }}
  //         icon={<MdSubtitles />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.status === 'Draft' ? false : true
  //         }
  //       >
  //         {t.submit}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       handleSubmit.mutate(purchaseRecieptDetails?.data?.name);
  //     },
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         style={{ width: '100%' }}
  //         icon={<TiCancel />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.docstatus === 1 ? false : true
  //         }
  //       >
  //         {t.Cancel}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       handleCancle.mutate(purchaseRecieptDetails?.data?.name);
  //     },
  //   },
  //   {
  //     key: '3',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<FaFileInvoiceDollar />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.status === 'To Bill' ? false : true
  //         }
  //       >
  //         {t.AddInvoice}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(
  //         `/purchase-reciept/add-invoice/${purchaseRecieptDetails?.data?.name}`
  //       );
  //     },
  //   },
  //   {
  //     key: '4',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<GiFiles />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.docstatus === 1 ? false : true
  //         }
  //       >
  //         {t.GeneralLedger}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(navigate(`/general-ledger-report-reciept/${id}`));
  //     },
  //   },
  //   {
  //     key: '5',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<SiKnowledgebase />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.docstatus === 1 ? false : true
  //         }
  //       >
  //         {t.StockLedger}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(navigate(`/stock-ledger-report-reciept/${id}`));
  //     },
  //   },
  //   {
  //     key: '6',
  //     label: (
  //       <Button
  //         size="small"
  //         type="text"
  //         icon={<GiReturnArrow />}
  //         disabled={
  //           purchaseRecieptDetails?.data?.status !== 'Draft'
  //             ? false
  //             : purchaseRecieptDetails?.data?.status !== 'Return Issued'
  //             ? false
  //             : true
  //         }
  //       >
  //         {t.purchaseReturn}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(navigate(`/purchase-reciept/return/${id}`));
  //     },
  //   },
  // ];
  const items = (record) => [
    {
      key: '1-1',
      label: t.StockLedger,
      icon: <SiKnowledgebase />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/stock-ledger-report-reciept/${record?.name}`),
    },
    {
      key: '1-2',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/general-ledger-report-reciept/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '3',
      label: t.AddInvoice,
      icon: <FaFileInvoiceDollar />,
      disabled: record?.status === 'To Bill' ? false : true,
      onClick: () => {
        navigate(`/purchase-reciept/add-invoice/${record?.name}`);
      },
    },
    {
      key: '4',
      label: t.purchaseReturn,
      disabled:
        record?.status !== 'Draft'
          ? false
          : record?.status !== 'Return Issued'
          ? false
          : true,
      icon: <GiReturnArrow />,
      onClick: () => navigate(`/purchase-reciept/return/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      disabled: record?.status === 'Draft' ? false : true,
      onClick: () => handleSubmit.mutate(record?.name),
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancle.mutate(record?.name),
    },
  ];
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={
          edit
            ? t.editPurchaseReciept
            : show
            ? t.purchaseReturn
            : showReturn
            ? t.purchaseReturn
            : t.addPurchaseReciept
        }
        status={purchaseRecieptDetails?.data?.status}
        path="/purchase-receipt"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.Inventory}
        subTitle={
          edit
            ? t.editPurchaseReciept
            : show
            ? t.purchaseReturn
            : showReturn
            ? t.purchaseReturn
            : t.addPurchaseReciept
        }
        icon={<MdOutlineReceiptLong />}
      />
      <Card
        style={{
          borderRadius: '0px',
        }}
      >
        <Flex justify="end" align="center">
          {edit && (
            <Dropdown
              menu={{ items: items(purchaseRecieptDetails?.data) }}
              className="btn-light"
              trigger={['click']}
              arrow
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          form={form}
          name="add-purchase-order"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            taxes: [{}],
            payment_schedule: [{}],
            items: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier"
                    label={t.Supplier}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Supplier}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={false}
                      popupMatchSelectWidth={false}
                      // options={customer?.message?.map((item) => ({
                      //   value: item?.value,
                      //   label: item?.value,
                      // }))}
                      onChange={(value) => {
                        handleGetDetails(value);
                      }}
                      onSearch={(value) => setSearchtextSupplier(value)}
                    >
                      {Supplier?.message?.map((item) => (
                        <Select.Option key={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier_name_in_arabic"
                    label={t.SupplierNameInArabic}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.SupplierNameInArabic} disabled />
                  </Form.Item>
                </Col> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      disabled={showReturn}
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_time"
                    label={t.postingTime}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <TimePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingTime}
                      format="HH:mm"
                      disabled={showReturn}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      disabled={showReturn}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="set_posting_time"
                    label={t.setPostingTime}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox disabled={showReturn} />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.currencyAndPriceList}</Divider>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="currency"
                label={t.currency}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={'SAR'}
              >
                <Input placeholder={t.currency} disabled />
              </Form.Item>
            </Col> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="buying_price_list"
                    label={t.buyingPriceList}
                    // rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.buyingPriceList}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      disabled={showReturn}
                      onChange={(value, option) => {
                        setPriceListSelect(value);
                        form.setFieldsValue({
                          price_list_currency: option?.option?.description,
                        });
                      }}
                      options={priceList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="is_return"
                    label={t.isReturn}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox disabled={showReturn} />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="disable_rounded_total"
                    label={t.disableRoundedTotal}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox disabled={showReturn} />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="apply_putaway_rule"
                label={t.applyPutawayRule}
                initialValue={0}
                className="custom_plus_riyal"
              >
                <Radio.Group disabled={show}>
                  <Radio value={1}>{t.yes}</Radio>
                  <Radio value={0}>{t.no}</Radio>
                </Radio.Group>
              </Form.Item>
            </Col> */}

                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="base_discount_amount"
                label={t.baseDiscountAmount}
              >
              <Input 
                placeholder={t.baseDiscountAmount}
                type="number"
                min={0}
               step="0.01"
               disabled={show}
              />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="additional_discount_percentage"
                label={t.additionalDiscountPercentage}
              >
              <Input 
                placeholder={t.additionalDiscountPercentage}
                type="number"
                min={0}
                disabled={show}
              />
              </Form.Item>
            </Col> */}
                <Divider orientation="left">{t.items}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setDataSource(
                          dataSource.map((item) => {
                            return {
                              ...item,
                              warehouse: value,
                            };
                          })
                        );
                      }}
                      disabled={showReturn}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: '20px' }}>
                  <ItemOrderList
                    view={showReturn}
                    type="Purchase Reciept"
                    // keyData="Purchase Reciept"
                    keyData="Sales Order"
                    priceList={priceListSelect}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    form={form}
                    // itemsList={itemsList}
                    warehouse={warehouse}
                    t={t}
                  />
                </Col>
                <Divider orientation="left">{t.TaxesandCharges}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="taxes_and_charges"
                    label={t.TaxesandCharges}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.TaxesandCharges}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      disabled={showReturn}
                      onChange={(value) => {
                        setLoadingTaxesDetails(true);
                        onGetTaxes(value);
                      }}
                      options={taxesCharges?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <TaxtList
                    t={t}
                    form={form}
                    data={taxesDetails}
                    loadingTaxesDetails={loadingTaxesDetails}
                  />
                </Col>
                <Divider />
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_qty"
                    label={t.totalQty}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.totalQty}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total"
                    label={t.Total}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.Total}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="net_total"
                    label={t.netTotal}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.netTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="grand_total" label={t.grandTotal}>
                    <Input
                      placeholder={t.grandTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="rounded_total" label={t.roundedTotal}>
                    <Input
                      placeholder={t.roundedTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="rounding_adjustment"
                    label={t.roundingAdjustment}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.roundingAdjustment}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{ marginTop: '10px' }}
                >
                  <Form.Item name="apply_discount_on" label={t.applyDiscountOn}>
                    <Select
                      placeholder={t.applyDiscountOn}
                      options={[
                        {
                          value: 'Grand Total',
                          label: t.GrandTotal,
                        },
                        {
                          value: 'Net Total',
                          label: t.netTotal,
                        },
                      ]}
                      disabled={showReturn}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="discount_type"
                    label={t.discountType}
                    style={{ marginBottom: 0 }}
                  >
                    <Select
                      placeholder={t.discountType}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Percentage',
                          label: t.percentage,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                      ]}
                      disabled={showReturn}
                    />
                  </Form.Item>
                </Col>
                {disountApplyType === 'Amount' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="base_discount_amount" label={t.value}>
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                        disabled={showReturn}
                      />
                    </Form.Item>
                  </Col>
                )}
                {disountApplyType === 'Percentage' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="additional_discount_percentage"
                      label={t.value}
                    >
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                        disabled={showReturn}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                {!showReturn && (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (submitButton) {
                        setLoadingAdd(true);
                        handleSubmit.mutate(selectName);
                      } else {
                        form.submit();
                      }
                    }}
                    loading={loadingAdd}
                  >
                    {submitButton ? t.submit : edit ? t.edit : t.Save}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddPurchaseReciept;
